import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AppServerAPI, DialogService, DictionaryEntry, MasterDetailListEntry, SelectFieldOption, TranslationService } from '@sdbn/common';
import { EntranceByCarCategory, TerminalLoginType, VisitorRole, VisitorRoleInfoText, VisitorRoleTask } from '../../visit-roles.model';
import { VisitRoleTaskDialogComponent } from '../visit-role-task-dialog/visit-role-task-dialog.component';

@Component({
    selector: 'app-visit-role-admin',
    templateUrl: './visit-role-admin.component.html',
    styleUrls: ['./visit-role-admin.component.scss'],
    standalone: false
})
export class VisitRoleAdminComponent implements OnInit {

  formGroup = new FormGroup({});

  currentVisitRole = new VisitorRole();
  selectedVisitorRole: VisitorRole;
  // currentVisitRole: VisitRole;
  roles = new Array<VisitorRole>();

  entranceByCarCategories: Array<SelectFieldOption>;
  terminalLoginTypes: Array<SelectFieldOption>;

  ignoreValueChanges = false;

  constructor(
    public translationService: TranslationService,
    private appServerAPI: AppServerAPI,
    private dialog: MatDialog,
    private dialogService: DialogService
  ) {

    let data = new Array<SelectFieldOption>();
    for (const k of Object.keys(EntranceByCarCategory)) {
      data.push(new SelectFieldOption({ labelDictionaryKey: 'tmc-visit.common.enum.entranceByCarCategory.' + EntranceByCarCategory[k], value: EntranceByCarCategory[k] }));
    }
    this.entranceByCarCategories = data;

    data = new Array<SelectFieldOption>();
    for (const k of Object.keys(TerminalLoginType)) {
      data.push(new SelectFieldOption({ labelDictionaryKey: 'tmc-visit.common.enum.requireTerminalLoginType.' + TerminalLoginType[k], value: TerminalLoginType[k] }));
    }
    this.terminalLoginTypes = data;

  }

  ngOnInit(): void {

    this.createFormGroup();
    this.loadAll();

  }

  createFormGroup() {

    console.log('creating form');

    this.formGroup = new FormGroup({});
    this.formGroup.addControl('entranceByCarCategory', new FormControl('', []));
    this.formGroup.addControl('allowYardEntranceByCar', new FormControl('', []));
    this.formGroup.addControl('allowYardEntranceOnFoot', new FormControl('', []));
    this.formGroup.addControl('allowOverrideRoleSettings', new FormControl('', []));
    this.formGroup.addControl('invitationRequiresConfirmation', new FormControl('', []));
    this.formGroup.addControl('invitationConfirmationOnAccessOnly', new FormControl('', []));
    this.formGroup.addControl('assignPrivilegesOnInvitation', new FormControl('', []));
    this.formGroup.addControl('invitationRequiresConfirmation', new FormControl('', []));
    this.formGroup.addControl('invitationConfirmationOnAccessOnly', new FormControl('', []));
    this.formGroup.addControl('assignPrivilegesOnInvitation', new FormControl('', []));
    this.formGroup.addControl('requireTerminalLogin', new FormControl('', []));
    this.formGroup.addControl('requireTerminalLoginType', new FormControl('', []));
    this.formGroup.addControl('requireInstructionsDone', new FormControl('', []));
    this.formGroup.addControl('oneTimeVisit', new FormControl('', []));
    this.formGroup.addControl('validDaysCount', new FormControl('', [Validators.required]));
    this.formGroup.addControl('showInTerminal', new FormControl('', []));
    this.formGroup.addControl('onlySecuredAccess', new FormControl('', []));
    this.formGroup.addControl('includeRegistrationQRCodeInMail', new FormControl('', []));
    this.formGroup.addControl('cleanupAfterHours', new FormControl('', [Validators.required]));
    this.formGroup.addControl('deleteAfterHours', new FormControl('', [Validators.required]));
    this.formGroup.addControl('icon', new FormControl('', []));
    this.formGroup.addControl('upfrontRegistrationMailBody', new FormControl('', []));


    this.formGroup.valueChanges.subscribe(values => {

      if (this.ignoreValueChanges) {
        return;
      }

      console.log('handling value changes', values);

      this.currentVisitRole.entranceByCarCategory = values.entranceByCarCategory;
      this.currentVisitRole.allowYardEntranceByCar = values.allowYardEntranceByCar;
      this.currentVisitRole.allowYardEntranceOnFoot = values.allowYardEntranceOnFoot;
      this.currentVisitRole.allowOverrideRoleSettings = values.allowOverrideRoleSettings;
      this.currentVisitRole.invitationRequiresConfirmation = values.invitationRequiresConfirmation;
      this.currentVisitRole.invitationConfirmationOnAccessOnly = values.invitationConfirmationOnAccessOnly;
      this.currentVisitRole.assignPrivilegesOnInvitation = values.assignPrivilegesOnInvitation;
      this.currentVisitRole.invitationRequiresConfirmation = values.invitationRequiresConfirmation;
      this.currentVisitRole.invitationConfirmationOnAccessOnly = values.invitationConfirmationOnAccessOnly;
      this.currentVisitRole.assignPrivilegesOnInvitation = values.assignPrivilegesOnInvitation;
      this.currentVisitRole.requireTerminalLogin = values.requireTerminalLogin;
      this.currentVisitRole.requireTerminalLoginType = values.requireTerminalLoginType;
      this.currentVisitRole.requireInstructionsDone = values.requireInstructionsDone;
      this.currentVisitRole.oneTimeVisit = values.oneTimeVisit;
      this.currentVisitRole.showInTerminal = values.showInTerminal;
      this.currentVisitRole.cleanupAfterHours = values.cleanupAfterHours;
      this.currentVisitRole.deleteAfterHours = values.deleteAfterHours;
      this.currentVisitRole.validDaysCount = values.validDaysCount;
      this.currentVisitRole.includeRegistrationQRCodeInMail = values.includeRegistrationQRCodeInMail;
      this.currentVisitRole.icon = values.icon;
      this.currentVisitRole.onlySecuredAccess = values.onlySecuredAccess;
      this.currentVisitRole.upfrontRegistrationMailBody = values.upfrontRegistrationMailBody;

    });
  }

  patchFormValues() {
    console.log('patching form values', this.currentVisitRole);


    this.ignoreValueChanges = true;

    if (this.formGroup != null) {
      this.formGroup.patchValue({
        id: this.currentVisitRole != null ? this.currentVisitRole.id : null,
        entranceByCarCategory: this.currentVisitRole != null ? this.currentVisitRole.entranceByCarCategory : null,
        allowYardEntranceByCar: this.currentVisitRole != null ? this.currentVisitRole.allowYardEntranceByCar : null,
        allowYardEntranceOnFoot: this.currentVisitRole != null ? this.currentVisitRole.allowYardEntranceOnFoot : null,
        allowOverrideRoleSettings: this.currentVisitRole != null ? this.currentVisitRole.allowOverrideRoleSettings : null,
        invitationRequiresConfirmation: this.currentVisitRole != null ? this.currentVisitRole.invitationRequiresConfirmation : null,
        invitationConfirmationOnAccessOnly: this.currentVisitRole != null ? this.currentVisitRole.invitationConfirmationOnAccessOnly : null,
        assignPrivilegesOnInvitation: this.currentVisitRole != null ? this.currentVisitRole.assignPrivilegesOnInvitation : null,
        requireTerminalLogin: this.currentVisitRole != null ? this.currentVisitRole.requireTerminalLogin : null,
        requireTerminalLoginType: this.currentVisitRole != null ? this.currentVisitRole.requireTerminalLoginType : null,
        requireInstructionsDone: this.currentVisitRole != null ? this.currentVisitRole.requireInstructionsDone : null,
        oneTimeVisit: this.currentVisitRole != null ? this.currentVisitRole.oneTimeVisit : null,
        validDaysCount: this.currentVisitRole != null ? this.currentVisitRole.validDaysCount : null,
        showInTerminal: this.currentVisitRole != null ? this.currentVisitRole.showInTerminal : null,
        includeRegistrationQRCodeInMail: this.currentVisitRole != null ? this.currentVisitRole.includeRegistrationQRCodeInMail : null,
        cleanupAfterHours: this.currentVisitRole != null ? this.currentVisitRole.cleanupAfterHours : null,
        deleteAfterHours: this.currentVisitRole != null ? this.currentVisitRole.deleteAfterHours : null,
        icon: this.currentVisitRole != null ? this.currentVisitRole.icon : null,
        onlySecuredAccess: this.currentVisitRole?.onlySecuredAccess,
        upfrontRegistrationMailBody: this.currentVisitRole?.upfrontRegistrationMailBody
      }, { emitEvent: false, onlySelf: true });
    }
    this.formGroup.markAsPristine();
    this.formGroup.markAsUntouched();

    this.ignoreValueChanges = false;


  }

  loadAll() {
    this.appServerAPI.execute<VisitorRole[]>('/client/admin/visitor-role/find-all', {}).subscribe(users => {

      let newRoles = new Array<VisitorRole>();
      for (let user of users) {
        newRoles.push(new VisitorRole(user));
      }
      this.roles = newRoles;


      let currentSelectedId = -1;
      if (this.selectedVisitorRole != null) {
        currentSelectedId = this.selectedVisitorRole.id;
      }

      const newSelectedUser = this.roles.find(user => user.id === currentSelectedId);
      console.log('user for selection is', newSelectedUser);
      if (newSelectedUser != null) {
        this.onSelectionChanged(newSelectedUser);
      } else if (this.roles.length > 0) {
        this.onSelectionChanged(this.roles[0]);
      }
    }, error => {
      console.error(error);
    });
  }

  cancel() {

    this.currentVisitRole = new VisitorRole(this.selectedVisitorRole);
    this.formGroup.markAsPristine();

  }

  save() {

    this.appServerAPI.execute<number>('/client/admin/visitor-role/save', this.currentVisitRole).subscribe(response => {
      if (response > 0) {
        this.loadAll();
        this.formGroup.markAsPristine();
      }
    }, error => {
      console.log(error);
    });

  }

  public onDictionaryChange(entry: DictionaryEntry) {
    this.formGroup.markAsDirty();
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    console.log('selection changed', entry);
    this.selectedVisitorRole = entry as VisitorRole;
    if (entry != null) {
      this.currentVisitRole = new VisitorRole(this.selectedVisitorRole);
      this.prepareInfotextList();
      this.patchFormValues();
    } else {
      this.currentVisitRole = null;
      this.patchFormValues();
    }
  }

  onAddEntry(selection: Array<MasterDetailListEntry>) {
    this.selectedVisitorRole = new VisitorRole();
  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    console.log('deletion event received for item', entry);
    this.dialogService.showConfirm('tmc-visit.visit-role-admin.ui.delete-role-confirm-title', 'tmc-visit.visit-role-admin.ui.delete-role-confirm-message').afterClosed().subscribe(result => {
      if (result) {
        const visitorRole = entry as VisitorRole;
        this.appServerAPI.execute<number>('/client/admin/visitor-role/delete', visitorRole.id).subscribe(response => {
          this.loadAll();
          this.formGroup.markAsPristine();
        }, error => {
          console.log(error);
        });
      }
    });
  }

  public removeInfotext(visitorRoleInfoText: VisitorRoleInfoText) {

    this.dialogService.showConfirm(
      'tmc-visit.widgets.visitor-role-administration.remove-infotext.confirm-dialog.title',
      'tmc-visit.widgets.visitor-role-administration.remove-infotext.confirm-dialog.message'
    ).afterClosed().subscribe(result => {
      if (result) {
        if (visitorRoleInfoText.id == null) {
          const index = this.currentVisitRole.informationTexts.indexOf(visitorRoleInfoText);
          this.currentVisitRole.informationTexts.splice(index, 1);
        } else {
          visitorRoleInfoText.deleted = true;
        }
      }
      this.updateInfotextIndex();
      this.formGroup.markAsDirty();
    });

  }

  public addInfotext() {
    this.currentVisitRole.informationTexts.push(new VisitorRoleInfoText({
      id: null,
      text: new DictionaryEntry(),
      deleted: false
    }));
    this.updateInfotextIndex();
    this.formGroup.markAsDirty();
  }

  public addTask() {
    this.dialogService.openDefault(VisitRoleTaskDialogComponent, new VisitorRoleTask()).afterClosed().subscribe(result => {
      if (result != null) {
        this.currentVisitRole.tasks.push(result);
        this.formGroup.markAsDirty();
      }
    });
  }

  public editTask(task: VisitorRoleTask) {
    this.dialogService.openDefault(VisitRoleTaskDialogComponent, new VisitorRoleTask(task)).afterClosed().subscribe(result => {
      if (result != null) {
        const index = this.currentVisitRole.tasks.indexOf(task);
        this.currentVisitRole.tasks[index] = result;
        this.formGroup.markAsDirty();
      }
    });
  }

  public markDeleted(task: VisitorRoleTask) {
    task.deleted = true;
    this.formGroup.markAsDirty();
  }

  public unmarkDeleted(task: VisitorRoleTask) {
    task.deleted = false;
    this.formGroup.markAsDirty();
  }

  public drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.currentVisitRole.informationTexts, event.previousIndex, event.currentIndex);
    this.updateInfotextIndex();
    this.formGroup.markAsDirty();
  }
  private updateInfotextIndex() {

    let index = 0;
    for (const infotext of this.currentVisitRole.informationTexts) {
      infotext.index = index++;
    }
  }

  private prepareInfotextList() {
    this.currentVisitRole.informationTexts.sort((a: VisitorRoleInfoText, b: VisitorRoleInfoText) => {
      return a.id - b.id;
    });
    this.currentVisitRole.informationTexts.sort((a: VisitorRoleInfoText, b: VisitorRoleInfoText) => {
      return a.index - b.index;
    });
  }
}
